import React, { Component, Suspense } from "react";
import axios from "axios";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import AutoRenewOfferModal from "../components/AutoRenew/AutoRenewOfferModal";
import Loader from "../components/Loader/loader";
import {
  fetchAutoPayment,
  setAutoPaymentAccepted,
  shouldOfferAutoRenew,
  snoozeOffer,
} from "../utils/auto-payment";

// Lazy load Plans component for faster initial load
const Plans = React.lazy(() => import("../components/Plans/plans"));

const storeId = process.env.REACT_APP_STOREID;
const base_services_api = process.env.REACT_APP_SERVICES_API_BASE;

// eventId, ticketId нь amsys дээр бүхэл тоо (premium-event-link.js-тэй адил шалгуур).
const isId = value => /^\d+$/.test(String(value === null || value === undefined ? "" : value));

/* Тасалбарын Sonsy тэмдгээр (/premium?eventId=..&ticketId=..) ирсэн хэрэглэгчийг
   зөвхөн багцын жагсаалт дээр анхаарлаа хандуулуулна — hero видео хэсэг
   тэдэнд шаардлагагүй тул нуугдана. */
// Апп-аас (in-app browser) ?userId=..&token=.. -ээр автомат нэвтрэлт хийж ирсэн эсэх
const isSilentLoginRequest = search => {
  const params = new URLSearchParams(search || "");
  return params.has("userId") && params.has("token");
};

const isEventTicketFocus = search => {
  const params = new URLSearchParams(search || "");
  return isId(params.get("eventId")) && isId(params.get("ticketId"));
};

class Premium extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: "default",
      subscription: "",
      currentTextIndex: 0,
      videoError: false,
      focusOnPlans: isEventTicketFocus((props.location && props.location.search) || ""),
      // Карт холбосон ч автомат сунгалт идэвхгүй хэрэглэгчид идэвхжүүлэх санал
      autoRenewOffer: null, // { userId, cardNumber }
      autoRenewOfferBusy: false,
      autoRenewOfferError: false,
      autoRenewOfferDone: false,
      /* Автомат нэвтрэлт явагдаж байх үед зөвхөн loader харуулна — hero
         зураг, багцын жагсаалт зэрэг нь нэвтрэх хүсэлттэй сүлжээгээр
         өрсөлдөхгүй. */
      silentLoggingIn: isSilentLoginRequest((props.location && props.location.search) || ""),
    };
    this.textArray = ["Мэдрэмжээ", "Зүрхээ", "Зүрхээ", "Гоё дуу", "Датагүй ч"];
    this.videoRef = React.createRef();
  }

  detectIOS = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  };

  async componentDidMount() {
    this.textInterval = setInterval(() => {
      this.setState(prevState => ({
        currentTextIndex: (prevState.currentTextIndex + 1) % this.textArray.length,
      }));
    }, 2000);

    this.auth = this.props.auth;
    try {
      const QueryParams = new URLSearchParams(this.props.location.search);
      if (QueryParams.has("userId") && QueryParams.has("token")) {
        this.setState({ isLoading: true });
        const userId = decodeURIComponent(QueryParams.get("userId"));
        const token = decodeURIComponent(QueryParams.get("token"));
        this.validateTokens(userId, token);
        // Нэвтэрсний дараа loginUser өөрөө багцыг шалгана
        return;
      }
    } catch (error) {
      console.error("Error in componentDidMount: ", error);
      this.setState({ errorMessage: error.message, silentLoggingIn: false });
    }
    this.checkSubscription();
  }

  componentWillUnmount() {
    if (this.textInterval) {
      clearInterval(this.textInterval);
    }
  }

  loginUser = async (accessToken, refreshToken) => {
    try {
      const data = jwt_decode(accessToken);
      this.auth.authData.sub = data.sub;
      this.setState({ isLoading: true }, () => {
        this.auth.authData.access_token = accessToken;
        this.auth.authData.refresh_token = refreshToken;
      });
      if (typeof window !== "undefined") {
        window.localStorage.setItem("silentLogin", "true");
      }
      // toast.success("Автомат нэвтрэлт амжилттай боллоо.");
      this.auth.storeAuth();

      /* Хуудсыг ДАХИН АЧААЛАХГҮЙ (window.location.href биш) — in-app
         browser-т бүх JS/CSS/зургийг дахин татах нь ачааллыг 2 дахин
         удаашруулж байсан. Auth нэг instance тул шилжилтийн дараа
         header ч нэвтэрсэн төлөвөөр зурагдана. */
      let hasSubscription = false;
      try {
        const subscriptionsData = await this.auth.loadSubscriptions();
        hasSubscription = subscriptionsData.data.length > 0;
      } catch (error) {
        hasSubscription = false;
      }
      if (hasSubscription) {
        this.props.history.replace("/profile");
        return;
      }
      // Багцгүй: энэ хуудсандаа үлдэж, токеныг хаягаас арилгана
      this.props.history.replace("/premium");
      this.setState({ silentLoggingIn: false, isLoading: false });
      this.checkSubscription();

      // setTimeout(() => {
      // }, 1000);
    } catch (error) {
      this.setState({ silentLoggingIn: false });
      toast.error("Автомат нэвтрэлт амжилтгүй боллоо. Та дахин нэвтэрнэ үү.");
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("silentLogin");
      }
      console.log("Silent login error: ", error);
      // window.location.href = "/premium";
    }
  };
  validateTokens(userId, token) {
    console.log("validateTokens request", {
      userId,
      token,
    });
    this.setState({ isLoading: true });
    axios
      .post(`${process.env.REACT_APP_SERVICES_API_BASE}/users/${userId}/validateHMAC`, null, {
        headers: { Authorization: `Tuned-HMAC ${token}` },
      })
      .then(async resp => {
        console.log("validateTokens response", resp);

        console.log("checkout response", resp);
        if (resp.status === 200) {
          this.auth.getUserLoginInfo(userId, resp.data.access_token);
          this.auth.authData = resp.data;
          this.loginUser(resp.data.access_token, resp.data.refresh_token);
        } else {
          this.setState({ silentLoggingIn: false });
          console.log("can't login response not 200", {
            error: resp,
            userId,
            token,
          });
        }
      })
      .catch(err => {
        // Нэвтэрч чадаагүй — энгийн premium хуудсаа харуулна
        this.setState({ silentLoggingIn: false });
        this.checkSubscription();
        console.error("Error from validateTokens", {
          error: err,
          userId,
          token,
        });
        let message = err.message;
        if (err.response) {
          console.log("Error response: ", err.response);
          if (err.response.status === 401) {
            message =
              "Unauthorized access. The request was unacceptable, often due to missing a required parameter.";
          } else if (err.response.status === 402) {
            message = "The parameters were valid but the request failed.";
          } else if (err.response.status === 403) {
            message = "The API key doesnt have permissions to perform the request.";
          } else if (err.response.status === 404) {
            message = "The requested resource does not exist.";
          } else if (err.response.status === 400) {
            message =
              "Unauthorized access. The request was unacceptable, often due to missing a required parameter.";
          }
        }
        toast.error(message);
        this.setState({
          errorModal: true,
          errorMessage: message,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      });
  }

  checkSubscription = async () => {
    if (this.auth.isAuthenticated()) {
      try {
        const resp = await axios.get(
          `${base_services_api}/users/${this.props.auth.authData.sub}/profile`,
          {
            headers: {
              StoreId: storeId,
              Authorization: `Bearer ${this.props.auth.authData.access_token}`,
            },
          },
        );

        /* Хариунаас ШУУД уншина — `setState` -ийн дараа `this.state` -ыг
           тэр дор нь унших нь найдваргүй. */
        const subscription = resp.data.Subscriptions[0];
        this.setState({ subscription });

        if (subscription) {
          this.setState({ isLoading: true });
          /* Идэвхтэй багцтай хэрэглэгч багц авах хуудсанд хэрэггүй.
             ШАЛТГААНЫГ нь хамт дамжуулна — эс бөгөөс тэр яагаад нүүр
             хуудас руу шидэгдсэнээ ойлгохгүй (`containers/home.js`).

             `replace` (`href` БИШ): буцах товч дарахад энэ хуудсанд
             дахин орж, дахин шидэгдэх гогцоо үүсгэхгүй. */
          window.location.replace("/?activeSubscription=1");
          return;
        }

        // Идэвхтэй багцгүй — өмнө карт холбосон бол автомат сунгалтыг санал болгоно
        this.checkAutoRenewOffer();
      } catch (error) {
        console.error("Error checking subscription:", error);
      }
    }
  };

  checkAutoRenewOffer = async () => {
    const { sub: userId, access_token } = this.props.auth.authData;
    try {
      const record = await fetchAutoPayment(userId, access_token);
      if (shouldOfferAutoRenew(record, userId)) {
        this.setState({ autoRenewOffer: { userId, cardNumber: record.cardNumber } });
      }
    } catch (error) {
      console.error("Failed to check auto-renew offer:", error);
    }
  };

  acceptAutoRenewOffer = async () => {
    const { userId } = this.state.autoRenewOffer;
    this.setState({ autoRenewOfferBusy: true, autoRenewOfferError: false });
    try {
      await setAutoPaymentAccepted(userId, true, this.props.auth.authData.access_token);
      this.setState({ autoRenewOfferBusy: false, autoRenewOfferDone: true });
    } catch (error) {
      console.error("Failed to enable auto-renew:", error);
      this.setState({ autoRenewOfferBusy: false, autoRenewOfferError: true });
    }
  };

  declineAutoRenewOffer = () => {
    snoozeOffer(this.state.autoRenewOffer.userId);
    this.setState({ autoRenewOffer: null });
  };

  render() {
    const toastContainerStyle = {
      zIndex: 1001,
    };
    const auth = this.props.auth;

    if (this.state.silentLoggingIn) {
      return (
        <div className="page-content" id="content">
          <ToastContainer position="top-right" autoClose={5000} hideProgressBar style={toastContainerStyle} />
          <div
            role="status"
            aria-live="polite"
            style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <Loader />
          </div>
        </div>
      );
    }

    return (
      <div className="page-content" id="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={toastContainerStyle}
        />
        <section
          className="premium-payment text-white mt-5"
          id="premium-payment"
          style={{ backgroundColor: "black" }}
        >
          {/* .row-ийн -15px margin-ийг шингээж, хуудас хэвтээ чиглэлд халихаас сэргийлнэ */}
          <div className="container-fluid">
            <Row id="creditcard">
              <Col id="creditcard" sm="12" md="12" lg={{ span: 10, offset: 1 }}>
                {!this.state.focusOnPlans && (
                  <div className="title-sec black text-center wow fadeInUp mb-1 mt-4 align-items-center d-flex flex-column">
                    <h2 className="text-white">
                      <Translate id="content.buy-premium" />
                    </h2>
                    <div className="premium-subtitle">
                      <Translate id="content.premium_subtitle" />
                    </div>
                  </div>
                )}
                <Suspense
                  fallback={
                    <Col sm="12" className="text-center">
                      <div
                        style={{
                          minHeight: "400px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </Col>
                  }
                >
                  <Plans auth={auth} {...this.props} />
                </Suspense>
              </Col>
            </Row>
          </div>
        </section>
        <AutoRenewOfferModal
          open={!!this.state.autoRenewOffer}
          cardNumber={this.state.autoRenewOffer && this.state.autoRenewOffer.cardNumber}
          busy={this.state.autoRenewOfferBusy}
          error={this.state.autoRenewOfferError}
          done={this.state.autoRenewOfferDone}
          onAccept={this.acceptAutoRenewOffer}
          onDecline={this.declineAutoRenewOffer}
          onDismiss={() => this.setState({ autoRenewOffer: null })}
        />
      </div>
    );
  }
}

export default withLocalize(Premium);
